export interface Drama {
  id: string;
  title: string;
  category: "movie" | "tv";
  genres: string[];
  year: number;
  region: string;
  duration: string;
  director: string;
  cast: string[];
  rating: number;
  views: number;
  tags: string[];
  poster: string;
  backdrop: string;
  summary: string;
  synopsis: string;
  updatedAt: string;
  topics: string[];
}

export const dramas: Drama[] = [
  {
    id: "chang-an-shi-er-shi-chen",
    title: "长安十二时辰",
    category: "tv",
    genres: ["古装", "悬疑", "动作"],
    year: 2019,
    region: "中国大陆",
    duration: "全48集",
    director: "曹盾",
    cast: ["雷佳音", "易烊千玺", "周一围", "热依扎"],
    rating: 8.9,
    views: 128600000,
    tags: ["盛唐气象", "限时缉凶", "高还原"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20period%20drama%20poster%2C%20Tang%20dynasty%20city%20walls%20at%20dusk%2C%20lone%20guard%20figure%20in%20dark%20crimson%20robe%20holding%20a%20lantern%2C%20misty%20mountain%20silhouette%2C%20warm%20amber%20light%20against%20deep%20ink%20background%2C%20elegant%20poster%20composition%2C%20rich%20texture%2C%20no%20text&width=600&height=840&seq=cgzy-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20wide%20shot%20of%20ancient%20Tang%20dynasty%20capital%20city%20at%20golden%20hour%2C%20layered%20wooden%20pavilions%20and%20stone%20walls%2C%20warm%20lantern%20glow%2C%20thin%20mist%2C%20dark%20crimson%20sky%2C%20cinematic%20atmosphere%2C%20no%20text&width=1600&height=760&seq=cgzy-backdrop-01&orientation=landscape",
    summary: "天宝三载上元节前夕，死囚张小敬临危受命，须在十二时辰内阻止一场足以倾覆长安的阴谋。",
    synopsis:
      "上元节灯会将近，长安城内外张灯结彩，暗流却在灯火之下悄然涌动。靖安司主事李必查获线索，得知有一批可疑的「狼卫」潜入城中，密谋在上元夜引发巨变。为在十二个时辰内破局，李必以赦免为条件，从死牢中提出前不良帅张小敬。两人一个身负旧案、熟悉长安每一条巷道，一个出身高门、手握全城望楼情报，在追查中不断碰撞又彼此托付。灯轮转动，时间步步逼近，长安的繁华与人心的幽微一并被照亮。",
    updatedAt: "2024-11-02",
    topics: ["经典国产剧集", "古装悬疑必看"],
  },
  {
    id: "liu-lang-di-qiu",
    title: "流浪地球",
    category: "movie",
    genres: ["科幻", "灾难", "剧情"],
    year: 2019,
    region: "中国大陆",
    duration: "125分钟",
    director: "郭帆",
    cast: ["吴京", "屈楚萧", "李光洁", "吴孟达"],
    rating: 8.6,
    views: 216800000,
    tags: ["硬科幻", "家园情结", "视效大片"],
    poster:
      "https://readdy.ai/api/search-image?query=Sci-fi%20Chinese%20film%20poster%2C%20giant%20planet%20engine%20tower%20rising%20above%20frozen%20earth%20city%2C%20tiny%20astronaut%20silhouette%2C%20crimson%20and%20orange%20engine%20light%20in%20dark%20blue%20ice%20landscape%2C%20cinematic%20poster%20composition%2C%20no%20text&width=600&height=840&seq=cgzy-poster-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Vast%20frozen%20earth%20surface%20with%20colossal%20planetary%20engines%20casting%20orange%20light%20into%20dark%20sky%2C%20distant%20space%20station%20silhouette%2C%20cinematic%20sci-fi%20scale%2C%20cold%20white%20and%20deep%20crimson%20tones%2C%20no%20text&width=1600&height=760&seq=cgzy-backdrop-02&orientation=landscape",
    summary: "太阳急速膨胀，人类启动「流浪地球」计划，用一万座行星发动机推动家园驶向新的星系。",
    synopsis:
      "近未来，太阳即将迎来氦闪，地球面临被吞没的命运。人类倾尽所有，在地表建造上万座行星发动机，推动整颗星球开启长达两千五百年的迁徙。十七年后，地球途经木星引力范围，意外引发全球性地震与发动机停摆，地木相撞进入倒计时。刚与家人重逢的刘启、妹妹韩朵朵与救援队一行人，在冰封的废墟上接力运送火石，只为让地球重新获得推力。这是一场以全人类为单位的归家之旅。",
    updatedAt: "2024-10-18",
    topics: ["2024热门电影", "国产科幻里程碑"],
  },
  {
    id: "man-jiang-hong",
    title: "满江红",
    category: "movie",
    genres: ["剧情", "悬疑", "古装"],
    year: 2023,
    region: "中国大陆",
    duration: "159分钟",
    director: "张艺谋",
    cast: ["沈腾", "易烊千玺", "张译", "雷佳音"],
    rating: 7.9,
    views: 186300000,
    tags: ["大院密室", "反转迭起", "小人物"],
    poster:
      "https://readdy.ai/api/search-image?query=Traditional%20Chinese%20noir%20film%20poster%2C%20narrow%20courtyard%20alley%20at%20night%2C%20two%20cloaked%20figures%20with%20torches%2C%20crimson%20lanterns%20and%20grey%20stone%20walls%2C%20heavy%20atmosphere%2C%20ink%20wash%20texture%2C%20no%20text&width=600&height=840&seq=cgzy-poster-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20residence%20rooftops%20at%20night%2C%20dim%20lantern%20light%20glowing%20in%20long%20stone%20alleys%2C%20layered%20tiled%20roofs%2C%20cold%20grey%20stone%20with%20warm%20red%20accents%2C%20mysterious%20cinematic%20mood%2C%20no%20text&width=1600&height=760&seq=cgzy-backdrop-03&orientation=landscape",
    summary: "宰相府邸一夜命案，小兵张大与亲兵营副统领各怀心事，层层棋局指向一首未落笔的词。",
    synopsis:
      "南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，身怀的密信不翼而飞。小兵张大与亲兵营副统领孙均机缘巧合被裹挟进这起大案，宰相府总管何立限他们一个时辰查明真相。随着审讯与试探层层推进，院中每个人都藏着秘密，一盘蓄谋已久的棋局缓缓展开，最终落在那首被传诵千年的词上。",
    updatedAt: "2024-09-27",
    topics: ["2024热门电影", "张艺谋作品"],
  },
  {
    id: "ren-shi-jian",
    title: "人世间",
    category: "tv",
    genres: ["剧情", "家庭", "年代"],
    year: 2022,
    region: "中国大陆",
    duration: "全58集",
    director: "李路",
    cast: ["雷佳音", "辛柏青", "宋佳", "殷桃"],
    rating: 9.1,
    views: 159400000,
    tags: ["平民史诗", "五十年光字片", "催泪"],
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20family%20saga%20drama%20poster%2C%20old%20northern%20china%20brick%20courtyard%20in%20snow%2C%20warm%20window%20light%2C%20two%20figure%20silhouettes%20at%20doorway%2C%20muted%20brown%20and%20cream%20palette%2C%20nostalgic%20film%20grain%2C%20no%20text&width=600&height=840&seq=cgzy-poster-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Snowy%20old%20worker%20district%20in%20northern%20China%2C%20low%20brick%20houses%20with%20warm%20lit%20windows%2C%20smokestacks%20in%20hazy%20distance%2C%20muted%20sepia%20tones%2C%20quiet%20nostalgic%20winter%20cinematic%20mood%2C%20no%20text&width=1600&height=760&seq=cgzy-backdrop-04&orientation=landscape",
    summary: "周家三兄妹跨越五十年的人生轨迹，写尽一座北方城市「光字片」里的人间烟火。",
    synopsis:
      "上世纪六十年代末，周家父亲周志刚响应号召奔赴西南，长子周秉义下乡，女儿周蓉为爱远走贵州，只剩小儿子周秉昆留在母亲身边。五十年间，光字片的青砖房拆了又建，一家人经历了三线建设、返城、下岗创业与城市改造。他们各自选择不同的道路，有坚守、有妥协、有不甘，也有在困境中彼此扶持的温度。这是一部写给平凡人的编年史。",
    updatedAt: "2024-08-30",
    topics: ["经典国产剧集", "年代家庭剧"],
  },
  {
    id: "kuang-biao",
    title: "狂飙",
    category: "tv",
    genres: ["犯罪", "悬疑", "剧情"],
    year: 2023,
    region: "中国大陆",
    duration: "全39集",
    director: "徐纪周",
    cast: ["张译", "张颂文", "李一桐", "张志坚"],
    rating: 8.5,
    views: 243600000,
    tags: ["扫黑纪事", "双雄对峙", "二十年跨度"],
    poster:
      "https://readdy.ai/api/search-image?query=Crime%20thriller%20Chinese%20drama%20poster%2C%20rain%20soaked%20southern%20city%20street%20at%20night%2C%20two%20men%20facing%20each%20other%20in%20silhouette%2C%20neon%20amber%20reflections%20on%20wet%20asphalt%2C%20dark%20teal%20shadows%20with%20crimson%20accent%2C%20gritty%20film%20look%2C%20no%20text&width=600&height=840&seq=cgzy-poster-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Rainy%20night%20city%20overpass%20in%20southern%20China%2C%20warm%20street%20lamps%20reflecting%20on%20wet%20roads%2C%20distant%20market%20alleyway%20glow%2C%20moody%20crime%20drama%20cinematography%2C%20dark%20tones%20with%20amber%20highlights%2C%20no%20text&width=1600&height=760&seq=cgzy-backdrop-05&orientation=landscape",
    summary: "一线刑警安欣与鱼贩高启强二十年纠缠，从人情到法理，一条街的兴衰映出一座城的暗面。",
    synopsis:
      "2000年，京海市的旧厂街市场里，鱼贩高启强与弟弟相依为命，一次偶然的冲突让他和年轻刑警安欣结下不解之缘。二十年间，高启强一步步从小贩走到商会会长，安欣则始终在追查那桩陈年旧案。两人都曾有过善意，也都在不同方向上被时代推着走。指导组进驻京海后，尘封的卷宗被重新翻开，那些被遮掩的权力与交易逐渐浮出水面。",
    updatedAt: "2024-09-12",
    topics: ["经典国产剧集", "扫黑题材"],
  },
  {
    id: "yin-shi-ji",
    title: "隐秘的角落",
    category: "tv",
    genres: ["悬疑", "犯罪", "剧情"],
    year: 2020,
    region: "中国大陆",
    duration: "全12集",
    director: "辛爽",
    cast: ["秦昊", "王景春", "荣梓杉", "史彭元"],
    rating: 8.8,
    views: 132700000,
    tags: ["短剧精品", "少年视角", "潮湿南方"],
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20suspense%20series%20poster%2C%20three%20children%20on%20a%20cliff%20by%20the%20sea%20seen%20from%20behind%2C%20overcast%20coastal%20town%2C%20fog%20and%20wet%20rocks%2C%20muted%20green%20and%20grey%20palette%20with%20warm%20sunset%20sliver%2C%20no%20text&width=600&height=840&seq=cgzy-poster-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Misty%20southern%20Chinese%20coastal%20town%20with%20old%20concrete%20apartments%2C%20sea%20cliff%20and%20damp%20green%20vegetation%2C%20overcast%20humid%20sky%2C%20quiet%20unsettling%20cinematic%20mood%2C%20no%20text&width=1600&height=760&seq=cgzy-backdrop-06&orientation=landscape",
    summary: "三个孩子在景区拍下一段杀人视频，一次交易让整个夏天都变得无法收场。",
    synopsis:
      "少年朱朝阳在暑假与儿时好友严良、普普重聚，三人到郊外爬山拍照，无意间用相机记录下张东升将岳父母推下悬崖的全过程。为了给普普的弟弟筹钱治病，他们决定用这段视频向凶手索要三十万。然而勒索只是开始，谎言像潮水一样漫上来，把每个家庭都卷了进去。阳光越烈，阴影越深。",
    updatedAt: "2024-07-21",
    topics: ["经典国产剧集", "悬疑短剧"],
  },
  {
    id: "ba-bai",
    title: "八佰",
    category: "movie",
    genres: ["战争", "历史", "剧情"],
    year: 2020,
    region: "中国大陆",
    duration: "147分钟",
    director: "管虎",
    cast: ["王千源", "张译", "姜武", "黄志忠"],
    rating: 7.6,
    views: 104800000,
    tags: ["四行仓库", "群像战争", "燃"],
    poster:
      "https://readdy.ai/api/search-image?query=War%20epic%20Chinese%20film%20poster%2C%20soldiers%20silhouettes%20holding%20position%20in%20a%20ruined%20warehouse%2C%20smoke%20and%20embers%20in%20air%2C%20window%20light%20breaking%20through%20dust%2C%20desaturated%20grey%20with%20ember%20orange%2C%20gritty%20texture%2C%20no%20text&width=600&height=840&seq=cgzy-poster-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Ruined%20concrete%20warehouse%20by%20a%20wide%20river%20at%20dusk%2C%20heavy%20smoke%20columns%2C%20searchlight%20beams%20crossing%20the%20sky%2C%20embers%20drifting%2C%20desaturated%20grey%20and%20ember%20orange%20war%20cinematography%2C%20no%20text&width=1600&height=760&seq=cgzy-backdrop-07&orientation=landscape",
    summary: "1937年的上海，四行仓库里的四百余名将士，用四天四夜守住了对岸的目光。",
    synopsis:
      "淞沪会战末期，中国军队第88师524团一营奉命留守苏州河北岸的四行仓库，对外号称八百人，实际上多为补充来的新兵。仓库与租界仅一河之隔，对岸的百姓隔着河水，看得见这边的每一发子弹与每一声呐喊。四天四夜里，散兵、老兵、逃兵在一场场攻防中被迫长大。这场战役没有退路，只有把旗立起来。",
    updatedAt: "2024-06-15",
    topics: ["战争历史必看"],
  },
  {
    id: "san-ti",
    title: "三体",
    category: "tv",
    genres: ["科幻", "悬疑", "剧情"],
    year: 2023,
    region: "中国大陆",
    duration: "全30集",
    director: "杨磊",
    cast: ["张鲁一", "于和伟", "陈瑾", "王子文"],
    rating: 8.7,
    views: 174200000,
    tags: ["硬核改编", "宇宙闪烁", "忠于原著"],
    poster:
      "https://readdy.ai/api/search-image?query=Science%20fiction%20Chinese%20series%20poster%2C%20lone%20scientist%20figure%20standing%20in%20a%20vast%20observatory%20dome%20under%20a%20giant%20red%20sun%2C%20starfield%20and%20radio%20telescope%20silhouette%2C%20deep%20black%20with%20crimson%20glow%2C%20no%20text&width=600&height=840&seq=cgzy-poster-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Vast%20night%20desert%20observatory%20with%20radio%20telescope%20dishes%2C%20dramatic%20red%20and%20orange%20sky%20anomaly%2C%20dust%20in%20air%2C%20lonely%20sci-fi%20cinematic%20landscape%2C%20no%20text&width=1600&height=760&seq=cgzy-backdrop-08&orientation=landscape",
    summary: "一场科学家的连环自杀，把纳米科学家汪淼推入一个名为「三体」的世界。",
    synopsis:
      "2007年，多名前沿科学家接连自杀，物理学界陷入恐慌。警官史强找到纳米材料专家汪淼，请他协助潜入一个名为「科学边界」的学术组织。汪淼在调查中进入《三体》游戏，亲眼见到一个在三颗太阳下反复毁灭又重生的世界，同时发现整个宇宙的微波背景辐射正在为他闪烁。当真相指向四十多年前的红岸基地，人类第一次意识到，自己在宇宙中并不孤单。",
    updatedAt: "2024-10-05",
    topics: ["2024热门电影", "国产科幻里程碑"],
  },
  {
    id: "yin-zhong-ren",
    title: "隐入尘烟",
    category: "movie",
    genres: ["剧情", "文艺", "家庭"],
    year: 2022,
    region: "中国大陆",
    duration: "133分钟",
    director: "李睿珺",
    cast: ["武仁林", "海清", "杨光锐", "赵登平"],
    rating: 8.3,
    views: 76800000,
    tags: ["西北乡村", "静默深情", "文艺佳作"],
    poster:
      "https://readdy.ai/api/search-image?query=Quiet%20art%20house%20Chinese%20film%20poster%2C%20two%20farmers%20working%20in%20a%20golden%20wheat%20field%20at%20sunset%2C%20mud%20brick%20house%20in%20distance%2C%20warm%20ochre%20and%20dusty%20earth%20palette%2C%20film%20grain%2C%20no%20text&width=600&height=840&seq=cgzy-poster-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Endless%20northwest%20Chinese%20farmland%20at%20golden%20hour%2C%20rows%20of%20wheat%2C%20dry%20earth%20road%2C%20a%20small%20brick%20house%2C%20warm%20ochre%20light%20and%20dust%20in%20air%2C%20minimal%20contemplative%20cinematography%2C%20no%20text&width=1600&height=760&seq=cgzy-backdrop-09&orientation=landscape",
    summary: "两个被家庭边缘的人结为夫妻，在西北的黄土地上，用最朴素的方式把日子过成了家。",
    synopsis:
      "西北农村，两个被各自家庭视为「累赘」的人被撮合到一起。男人沉默寡言、肯下力气，女人身体不好、手脚不便，他们从陌生到相依，一起种地、盖房、养鸡、孵小鸡。男人用麦粒在女人手背上按下花的形状，说这是给她种下的春天。土地一年的收成压在一个人的肩上，也在慢慢长出一点温柔。生活没有给他们太多余地，但他们认认真真地活过。",
    updatedAt: "2024-05-18",
    topics: ["文艺口碑之选"],
  },
  {
    id: "chun-chao",
    title: "春潮",
    category: "movie",
    genres: ["剧情", "家庭", "文艺"],
    year: 2019,
    region: "中国大陆",
    duration: "115分钟",
    director: "杨荔钠",
    cast: ["郝蕾", "金燕玲", "曲隽希", "李文波"],
    rating: 7.4,
    views: 43200000,
    tags: ["三代女性", "克制表达", "东北小城"],
    poster:
      "https://readdy.ai/api/search-image?query=Intimate%20family%20drama%20film%20poster%2C%20three%20generations%20of%20women%20in%20a%20dim%20northern%20chinese%20apartment%2C%20window%20frost%20and%20soft%20grey%20light%2C%20restrained%20composition%2C%20muted%20teal%20and%20beige%20tones%2C%20no%20text&width=600&height=840&seq=cgzy-poster-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Snowy%20old%20industrial%20town%20in%20northeast%20China%2C%20frozen%20river%20and%20bare%20trees%2C%20hazy%20afternoon%20light%20through%20window%2C%20muted%20cool%20palette%20with%20warm%20interior%20glow%2C%20no%20text&width=1600&height=760&seq=cgzy-backdrop-10&orientation=landscape",
    summary: "记者郭建波与母亲、女儿同住一个屋檐下，冰封的河面下，是三代人未说出口的话。",
    synopsis:
      "报社记者郭建波与母亲纪明岚、女儿郭婉婷生活在北方小城。母亲强势而擅长数落，女儿早熟又敏感，夹在中间的建波习惯用沉默回应一切。她一边追踪社会新闻，一边在自己的生活里失语。饭桌上的一句话、病房里的一次沉默、河边的一次呼吸，都在暗处积成洪流。直到某个春天，冰面开始破裂。",
    updatedAt: "2024-04-08",
    topics: ["文艺口碑之选"],
  },
  {
    id: "sa-ye",
    title: "沙野",
    category: "movie",
    genres: ["冒险", "剧情", "历史"],
    year: 2021,
    region: "中国大陆",
    duration: "128分钟",
    director: "蒙柯",
    cast: ["张逸", "刘婉", "陈立山", "罗西"],
    rating: 7.8,
    views: 58700000,
    tags: ["戈壁驼队", "国家地理级", "公路感"],
    poster:
      "https://readdy.ai/api/search-image?query=Desert%20adventure%20Chinese%20film%20poster%2C%20camel%20caravan%20crossing%20vast%20gobi%20dunes%20at%20dawn%2C%20dust%20clouds%20and%20long%20shadows%2C%20deep%20amber%20and%20burnt%20sienna%20palette%2C%20wide%20silhouette%20composition%2C%20no%20text&width=600&height=840&seq=cgzy-poster-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Endless%20gobi%20desert%20at%20dawn%20with%20mesa%20cliffs%20and%20dust%20clouds%2C%20small%20caravan%20silhouette%20on%20a%20dune%20ridge%2C%20amber%20sunlight%20and%20deep%20shadow%2C%20epic%20nature%20cinematography%2C%20no%20text&width=1600&height=760&seq=cgzy-backdrop-11&orientation=landscape",
    summary: "一支运送古籍的驼队穿越戈壁，风沙之中，每个人都在守护一样不能丢下的东西。",
    synopsis:
      "上世纪三十年代，西北戈壁上，一支由商队与护送者组成的队伍奉命将一批古籍与标本运往内陆。他们带着有限的驼队与补给，从绿洲出发穿越数百里无人区。途中遇上沙暴、水源断绝与不速之客，队里年轻的地质学生第一次意识到，脚下的土地比地图上复杂得多。驼铃一路向前，走出了一条关于守护与放弃的路。",
    updatedAt: "2024-10-22",
    topics: ["2024热门电影"],
  },
  {
    id: "fan-hua",
    title: "繁花",
    category: "tv",
    genres: ["剧情", "年代", "爱情"],
    year: 2023,
    region: "中国大陆",
    duration: "全30集",
    director: "王家卫",
    cast: ["胡歌", "马伊琍", "唐嫣", "辛芷蕾"],
    rating: 8.2,
    views: 208900000,
    tags: ["上海风情", "光影美学", "沪语版"],
    poster:
      "https://readdy.ai/api/search-image?query=Shanghai%20noir%20period%20series%20poster%2C%20stylish%20figure%20in%20a%20tailored%20suit%20standing%20in%20a%20neon%20lit%20alley%2C%20rain%20and%20reflections%2C%20warm%20amber%20and%20deep%20green%20shadows%2C%20retro%20film%20aesthetic%2C%20no%20text&width=600&height=840&seq=cgzy-poster-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=1990s%20Shanghai%20street%20at%20night%2C%20neon%20signs%20and%20old%20lane%20houses%2C%20rain%20slicked%20pavement%20with%20warm%20reflections%2C%20cinematic%20moody%20lighting%2C%20golden%20amber%20and%20deep%20teal%20palette%2C%20no%20text&width=1600&height=760&seq=cgzy-backdrop-12&orientation=landscape",
    summary: "九十年代的上海黄河路，阿宝从无名小商人一步步变成「宝总」，也一步步失去身边的人。",
    synopsis:
      "九十年代初，改革开放的浪潮拍打着黄浦江。青年阿宝在黄河路的小饭店里结识了老板玲子、外贸员汪小姐与神秘的李李。借着时代的东风与一点点运气，阿宝做起了自己的生意，路子越走越宽，成了人们口中的「宝总」。灯火越亮，身边的人越分散，曾经一起吃夜宵的伙伴各自走向不同的方向。一条街上，繁华如梦，醒来依旧要往前走。",
    updatedAt: "2024-10-12",
    topics: ["2024热门电影", "王家卫作品"],
  },
  {
    id: "yin-yuan-shi",
    title: "团圆",
    category: "movie",
    genres: ["剧情", "家庭"],
    year: 2024,
    region: "中国大陆",
    duration: "108分钟",
    director: "周砚",
    cast: ["李建国", "孙慧", "周小叶", "罗天"],
    rating: 8.0,
    views: 38600000,
    tags: ["小成本佳作", "年夜饭", "温暖"],
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20family%20drama%20film%20poster%2C%20old%20chinese%20dining%20table%20with%20steaming%20dishes%20and%20red%20paper%20lanterns%2C%20empty%20chairs%20and%20one%20lit%20window%2C%20cozy%20amber%20light%2C%20festive%20but%20quiet%20mood%2C%20no%20text&width=600&height=840&seq=cgzy-poster-13&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Small%20chinese%20town%20courtyard%20during%20lunar%20new%20year%2C%20red%20lanterns%20and%20warm%20window%20light%2C%20dumpling%20steam%2C%20family%20silhouettes%20behind%20frosted%20glass%2C%20warm%20cozy%20cinematic%20palette%2C%20no%20text&width=1600&height=760&seq=cgzy-backdrop-13&orientation=landscape",
    summary: "除夕夜，一顿散了多年的年夜饭重新摆上桌，四张椅子，等一个人。",
    synopsis:
      "小城的老屋要拆了，离家十年的女儿第一次回来。父亲在厨房里忙了一整天，桌上摆着永远少一道菜的除夕饭，母亲翻出旧相册，弟弟装作不在意地在门口抽烟。四个人各自有不肯开口的理由，一顿饭从热气腾腾吃到凉。当窗外的烟花响起，谁先说了第一句话，就决定了这个家还能不能重新拼起来。",
    updatedAt: "2024-11-08",
    topics: ["2024热门电影", "春节档口碑"],
  },
  {
    id: "hai-shang-jiu-wen",
    title: "海上旧闻",
    category: "tv",
    genres: ["悬疑", "年代", "剧情"],
    year: 2024,
    region: "中国大陆",
    duration: "全24集",
    director: "沈泊言",
    cast: ["韩冬", "叶璇", "许锐", "孟雪"],
    rating: 8.4,
    views: 92300000,
    tags: ["民国港城", "旧报纸", "连环谜案"],
    poster:
      "https://readdy.ai/api/search-image?query=Period%20mystery%20series%20poster%2C%20foggy%20harbor%20with%20old%20steamship%2C%20figure%20in%20trench%20coat%20reading%20a%20newspaper%20under%20a%20street%20lamp%2C%20sepia%20and%20cool%20grey%20palette%2C%20vintage%20film%20texture%2C%20no%20text&width=600&height=840&seq=cgzy-poster-14&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=1930s%20chinese%20harbor%20dock%20at%20dawn%2C%20fog%20over%20water%2C%20old%20steamship%20and%20cargo%20cranes%2C%20gas%20lamps%20along%20stone%20quay%2C%20sepia%20and%20cool%20grey%20cinematic%20tones%2C%20no%20text&width=1600&height=760&seq=cgzy-backdrop-14&orientation=landscape",
    summary: "一份停刊二十年的旧报纸重新出现，每一期都把一桩未破的旧案，重新摆到港城人眼前。",
    synopsis:
      "民国年间的港城，航运兴盛、报馆林立。一名任职于巡捕房的年轻探员在一处废宅中发现一批旧报纸，报纸上连载着尚未发生的凶案细节。与此同时，港城接连出现与之对应的命案。探员与一位在报馆做校对的女编辑联手，从铅字、油墨与码头账簿里抽丝剥茧，揭开一段被船舶与资本掩盖的往事。",
    updatedAt: "2024-10-28",
    topics: ["2024热门电影", "悬疑短剧"],
  },
  {
    id: "bei-shang",
    title: "北上",
    category: "tv",
    genres: ["剧情", "年代", "家庭"],
    year: 2024,
    region: "中国大陆",
    duration: "全40集",
    director: "徐向北",
    cast: ["林雨", "程曜", "周佩", "梁川"],
    rating: 8.1,
    views: 84600000,
    tags: ["运河人家", "百年变迁", "家族史"],
    poster:
      "https://readdy.ai/api/search-image?query=River%20town%20period%20drama%20poster%2C%20wooden%20boats%20on%20a%20grand%20canal%20at%20sunset%2C%20stone%20bridge%20and%20old%20white%20houses%2C%20warm%20golden%20reflections%20on%20water%2C%20nostalgic%20cinematic%20palette%2C%20no%20text&width=600&height=840&seq=cgzy-poster-15&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Grand%20canal%20waterway%20through%20an%20old%20chinese%20river%20town%20at%20golden%20hour%2C%20wooden%20freight%20boats%2C%20stone%20arched%20bridge%2C%20warm%20haze%20over%20water%2C%20nostalgic%20cinematic%20landscape%2C%20no%20text&width=1600&height=760&seq=cgzy-backdrop-15&orientation=landscape",
    summary: "运河边的一家人，从上世纪走到今天，船来了又走，河水一直向北。",
    synopsis:
      "运河穿城而过，沿岸的船帮、码头与老屋构成了几代人的生活。故事从五十年代的船工家庭讲起，父亲跑船、母亲在码头缝补，孩子们在河边长大。随着公路与铁路兴起，水运渐渐衰落，一家人有人迁往城市，有人守着老船。四十年后，最小的女儿带着相机回到河岸，拍下即将消失的街景。河水一直向北，记忆也是。",
    updatedAt: "2024-11-14",
    topics: ["经典国产剧集", "年代家庭剧"],
  },
  {
    id: "ye-xing",
    title: "夜行",
    category: "movie",
    genres: ["犯罪", "动作", "悬疑"],
    year: 2024,
    region: "中国大陆",
    duration: "118分钟",
    director: "孟昭",
    cast: ["吴竞", "李若宁", "陈鹤", "沈川"],
    rating: 7.7,
    views: 64200000,
    tags: ["都市追逐", "一夜之间", "类型片"],
    poster:
      "https://readdy.ai/api/search-image?query=Urban%20crime%20thriller%20poster%2C%20lone%20runner%20crossing%20an%20empty%20highway%20overpass%20at%20midnight%2C%20city%20lights%20bokeh%2C%20streaking%20tail%20lights%2C%20cool%20grey%20with%20crimson%20and%20orange%20accents%2C%20no%20text&width=600&height=840&seq=cgzy-poster-16&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Empty%20city%20expressway%20at%20midnight%2C%20neon%20signage%20and%20light%20trails%2C%20wet%20asphalt%20reflections%2C%20distant%20skyline%2C%20cool%20grey%20tones%20with%20warm%20amber%20glow%2C%20cinematic%20chase%20atmosphere%2C%20no%20text&width=1600&height=760&seq=cgzy-backdrop-16&orientation=landscape",
    summary: "代驾司机接到一单深夜长途，副驾的乘客带着一个不能打开的手提箱。",
    synopsis:
      "深夜十一点，代驾司机老周接到一单从城东到郊外的长途订单。乘客沉默、紧张，副驾放着一个上锁的手提箱，沿途不断有陌生车辆尾随。老周本想把人送到就收工，却在一个岔路口被迫做出选择。一夜之间，他从旁观者变成了这场追逐的一部分。天亮之前，他必须弄明白箱子里装的是什么，以及自己为什么被选中。",
    updatedAt: "2024-11-18",
    topics: ["2024热门电影"],
  },
  {
    id: "gui-lai",
    title: "归来",
    category: "movie",
    genres: ["剧情", "爱情", "年代"],
    year: 2014,
    region: "中国大陆",
    duration: "111分钟",
    director: "张艺谋",
    cast: ["陈道明", "巩俐", "张慧雯", "郭一鸣"],
    rating: 8.2,
    views: 89400000,
    tags: ["等待", "记忆", "克制"],
    poster:
      "https://readdy.ai/api/search-image?query=Restrained%20chinese%20period%20drama%20poster%2C%20elderly%20man%20standing%20in%20a%20train%20station%20hall%20with%20soft%20window%20light%2C%20empty%20wooden%20benches%2C%20muted%20grey%20and%20cream%20palette%2C%20quiet%20melancholy%20mood%2C%20no%20text&width=600&height=840&seq=cgzy-poster-17&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Old%20chinese%20railway%20station%20platform%20in%20soft%20afternoon%20light%2C%20empty%20tracks%20and%20bare%20trees%2C%20muted%20grey%20and%20cream%20tones%2C%20quiet%20melancholic%20cinematography%2C%20no%20text&width=1600&height=760&seq=cgzy-backdrop-17&orientation=landscape",
    summary: "离家多年的陆焉识终于归来，妻子却因病认不出他，他只好化名守在身边。",
    synopsis:
      "上世纪七十年代，被打成「右派」的陆焉识在转押途中逃回家乡，却因女儿的一念之差错失与妻子冯婉瑜的相见。多年后平反归来的他走进家门，发现婉瑜因心因性失忆，再也认不出自己。为了照顾她，陆焉识选择以「修琴的」「念信的」等陌生人的身份留在她身边，日复一日陪她去火车站接那个「今天回来」的人。",
    updatedAt: "2024-03-11",
    topics: ["经典国产剧集"],
  },
  {
    id: "tian-gou",
    title: "天狗",
    category: "movie",
    genres: ["剧情", "犯罪"],
    year: 2006,
    region: "中国大陆",
    duration: "100分钟",
    director: "戚健",
    cast: ["富大龙", "朱媛媛", "刘子枫", "高昌"],
    rating: 8.5,
    views: 51800000,
    tags: ["护林员", "现实题材", "孤勇"],
    poster:
      "https://readdy.ai/api/search-image?query=Rural%20realist%20chinese%20film%20poster%2C%20lone%20man%20in%20worn%20jacket%20standing%20at%20edge%20of%20a%20pine%20forest%20at%20dusk%2C%20hillside%20village%20in%20background%2C%20cold%20blue%20grey%20with%20warm%20earth%20tones%2C%20no%20text&width=600&height=840&seq=cgzy-poster-18&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Northern%20chinese%20mountain%20forest%20at%20dusk%2C%20dense%20pine%20trees%20and%20dry%20grass%2C%20small%20village%20at%20foot%20of%20hill%2C%20cold%20blue%20grey%20light%20with%20warm%20lamp%20glow%2C%20no%20text&width=1600&height=760&seq=cgzy-backdrop-18&orientation=landscape",
    summary: "伤残退伍军人李天狗守着一片林场，村子里的每一个人都在等他让步。",
    synopsis:
      "李天狗带着妻子和两个孩子来到偏远山村，担任护林员。他恪守职责，不许任何人动一棵树。然而这个村子世世代代靠砍伐为生，从村主任到乡邻，人人都希望他睁一只眼闭一只眼。断水、断电、被孤立、被威胁，一家人被推到了整个村子的对立面。他瘸着腿每天巡山，一步一步走过那条界线。",
    updatedAt: "2024-02-20",
    topics: ["经典国产剧集", "文艺口碑之选"],
  },
];

export interface Topic {
  id: string;
  name: string;
  desc: string;
  cover: string;
}

export const topics: Topic[] = [
  {
    id: "classic-tv",
    name: "经典国产剧集",
    desc: "口碑与收视双收的长篇剧作，值得反复重看",
    cover:
      "https://readdy.ai/api/search-image?query=Stack%20of%20vintage%20chinese%20television%20drama%20memory%2C%20old%20CRT%20set%20glowing%20warm%20in%20a%20dim%20living%20room%2C%20family%20photo%20frames%2C%20warm%20amber%20and%20sepia%20tones%2C%20nostalgic%20cinematic%20still%20life%2C%20no%20text&width=800&height=520&seq=cgzy-topic-01&orientation=landscape",
  },
  {
    id: "hot-2024",
    name: "2024热门电影",
    desc: "今年讨论度最高的国产大银幕作品",
    cover:
      "https://readdy.ai/api/search-image?query=Cinema%20hall%20interior%20with%20warm%20crimson%20velvet%20seats%20and%20glowing%20screen%20light%2C%20empty%20rows%20and%20projector%20beam%20in%20dust%2C%20atmospheric%20film%20still%2C%20no%20text&width=800&height=520&seq=cgzy-topic-02&orientation=landscape",
  },
  {
    id: "sci-fi",
    name: "国产科幻里程碑",
    desc: "从行星发动机到宇宙闪烁，东方科幻的想象",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20sci-fi%20landscape%20of%20a%20planetary%20engine%20tower%20under%20a%20crimson%20sky%2C%20particle%20light%20and%20vapor%2C%20dark%20stark%20horizon%2C%20cinematic%20conceptual%20art%2C%20no%20text&width=800&height=520&seq=cgzy-topic-03&orientation=landscape",
  },
  {
    id: "suspense",
    name: "悬疑短剧精选",
    desc: "一季见分晓，节奏紧凑，反转不断",
    cover:
      "https://readdy.ai/api/search-image?query=Foggy%20coastal%20town%20at%20dusk%20with%20narrow%20alley%20and%20a%20single%20streetlamp%2C%20long%20shadows%20on%20wet%20ground%2C%20muted%20green%20grey%20suspense%20mood%2C%20cinematic%20still%2C%20no%20text&width=800&height=520&seq=cgzy-topic-04&orientation=landscape",
  },
];

export const genreOptions: string[] = [
  "剧情",
  "悬疑",
  "动作",
  "古装",
  "科幻",
  "犯罪",
  "家庭",
  "年代",
  "战争",
  "冒险",
  "爱情",
  "文艺",
  "灾难",
  "历史",
];

export const yearOptions: number[] = [2024, 2023, 2022, 2021, 2019, 2014, 2006];

export const categoryOptions = [
  { value: "all", label: "全部" },
  { value: "movie", label: "电影" },
  { value: "tv", label: "电视剧" },
];